import { default as ActionsList } from './ActionsList';

export default ActionsList;
